export default "__VITE_ASSET__BpK0Dgmo__"